const viewDaysCount = 12;

export default viewDaysCount;
